let dexie = null
let authStore = null

// Helper function needed because this module can not inject anything and is not part of Vue ecosystem
function useInjects(dx, auth) {
  dexie = dx
  authStore = auth
  if (!import.meta.env.DEV) return;
  console.log(
    'Initialized Dexie',
    dexie == null ? 'NULL' : 'NOT NULL',
    'and authStore',
    authStore == null ? 'NULL' : 'NOT NULL'
  )
}

// We use console.log only in non production builds but in production builds, we log to an IDB table.
function log() {
  if (import.meta.env.DEV) {
    if (arguments === undefined || arguments.length === 0) {
      console.log('Params missing in log service')
      return
    }

    if (typeof console !== 'undefined') {
      console.log(...arguments)
    }
  }
  /*
  if (dexie != null && authStore != null) {
    const username = authStore.username
    const timestamp = Date.now()
    console.log('Trying to log', arguments)
    try {
      dexie.table('ApplicationLogs').put({
        username,
        timestamp,
        //logArgs: arguments?.length == 0 ? '' : JSON.stringify(arguments),
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Exception occurred posting logs', e, arguments)
    }
  }
  */
}

function debug() {
  if (import.meta.env.DEV) {
    if (arguments === undefined || arguments.length === 0) {
      console.debug('Params missing in log service')
      return
    }

    if (typeof console !== 'undefined') {
      console.debug(...arguments)
    }
  }
  /*
  if (dexie != null && authStore != null) {
    const username = authStore.username
    const timestamp = Date.now()
    console.log('Trying to log', arguments)
    try {
      dexie.table('ApplicationLogs').put({
        username,
        timestamp,
        //logArgs: arguments?.length == 0 ? '' : JSON.stringify(arguments),
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Exception occurred posting logs', e, arguments)
    }
  }
  */
}

export { log, debug, useInjects }
